import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String, title: String }

  shareX() {
    const url = encodeURIComponent(this.urlValue)
    const text = encodeURIComponent(this.titleValue)
    window.open(
      `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
      '_blank',
      'width=550,height=420'
    )
  }

  shareFacebook() {
    const url = encodeURIComponent(this.urlValue)
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      '_blank',
      'width=550,height=420'
    )
  }

  async copyLink() {
    try {
      await navigator.clipboard.writeText(this.urlValue)
      this.showToast('リンクをコピーしました')
    } catch {
      this.showToast('コピーに失敗しました')
    }
  }

  showToast(message) {
    const existing = document.querySelector('.media-toast')
    if (existing) existing.remove()

    const toast = document.createElement('div')
    toast.className = 'media-toast'
    toast.textContent = message
    document.body.appendChild(toast)

    toast.addEventListener('animationend', () => toast.remove())
  }
}
